var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.5,
    height: 9.417,
    viewBox: "0 0 13.5 9.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17211",
    "data-name": "Group 17211",
    transform: "translate(-1313.25 -25.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15490",
    "data-name": "Path 15490",
    d: "M1314,33.958h12",
    fill: "none",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15489",
    "data-name": "Path 15489",
    d: "M1314,30h12",
    fill: "none",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15488",
    "data-name": "Path 15488",
    d: "M1314,26.042h12",
    fill: "none",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.322f4547a90cc9404ef937bc82e2c19e.svg";
export { ForwardRef as ReactComponent };